export default __webpack_public_path__ + "static/media/phlcommunityfridge-7.90b23403.jpg";